import { z } from 'zod';

/** Route-state sections for the four independently owned Learning resources. */
export const crmCustomerLearningSectionSchema = z.enum([
  'courses',
  'registrations',
  'certifications',
  'attempts',
]);

/** Only server-supported scalar sort parameters may enter the URL. */
export const crmCustomerLearningSortSchema = z.enum([
  'courseStartAt',
  '-courseStartAt',
  'submittedAt',
  '-submittedAt',
  'certifiedAt',
  '-certifiedAt',
  'registrationNumber',
  '-registrationNumber',
  'studentPaymentStatus',
  '-studentPaymentStatus',
  'instructorPaymentStatus',
  '-instructorPaymentStatus',
  'cost',
  '-cost',
  'referenceType',
  '-referenceType',
  'registrationType',
  '-registrationType',
  'certifiedAt.desc',
  'certifiedAt.asc',
  'expiresAt.asc',
  'expiresAt.desc',
  'certificationCode.asc',
  'certificationCode.desc',
  'attemptDate.desc',
  'attemptDate.asc',
  'attemptResult.asc',
  'attemptResult.desc',
  'attemptScore.desc',
  'attemptScore.asc',
]);

/** Typed URL and canonical collection inputs; validation remains at the route/API boundaries. */
export type CrmCustomerLearningFilters = {
  certificationTypeId?: string;
  certifiedFrom?: string;
  certifiedTo?: string;
  costMax?: number;
  costMin?: number;
  courseId?: string;
  courseStatus?: string;
  courseTypeId?: string;
  dateFrom?: string;
  dateTo?: string;
  attemptedFrom?: string;
  attemptedTo?: string;
  instructorId?: string;
  instructorPaymentStatus?: string;
  learningItemId?: string;
  registrationId?: string;
  registrationReferenceType?: string;
  registrationType?: string;
  result?: string;
  schoolId?: string;
  studentPaymentStatus?: string;
  submittedFrom?: string;
  submittedTo?: string;
  type?: string;
};

export type CrmCustomerLearningSection = z.infer<typeof crmCustomerLearningSectionSchema>;
export type CrmCustomerLearningSort = z.infer<typeof crmCustomerLearningSortSchema>;
